/* eslint-disable react/prop-types */

import { DownloadIcon } from "@chakra-ui/icons";
import {
  Badge,
  Box,
  Button,
  Heading,
  Image,
  SimpleGrid,
  Text,
  VStack,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import LoadingSpinner from "../../LoadingSpinner";
import fileTypeImg from "../../media/fileTypeImg.png";
// const testData = [
//   {
//     container: "winter",
//     blob: "FAQ.txt",
//   },
//   {
//     container: "winter",
//     blob: "GPA 2025.pdf",
//   },
//   {
//     container: "winter",
//     blob: "GPA 2025.pdf",
//   },
//   {
//     container: "winter",
//     blob: "GPA 2025.pdf",
//   },
// ];

const DirectoryCards = ({ data }) => {
  const [directoryData, setDirectoryData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);

    fetch(`api/listBlobs?container=${data.container}`)
      .then((response) => response.json())
      .then((json) => {
        setDirectoryData(json);
        setIsLoading(false);
      })
      .catch(() => setIsLoading(false));
  }, [data]);

  return (
    <Box p={4} mx="auto">
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <>
          <Text fontSize="md" fontWeight="bold" mb={4}>
            Please click on the download button to download a file.
          </Text>

          <SimpleGrid columns={{ base: 1, sm: 2, md: 4 }} spacing={4}>
            {directoryData.map((directoryItem, index) => (
              <Box
                key={index}
                borderWidth="1px"
                borderRadius="lg"
                overflow="hidden"
                cursor="pointer"
                transition="all 0.3s"
                _hover={{
                  transform: "translateY(-4px)",
                  boxShadow: "xl",
                  borderColor: "blue.300",
                }}
                position="relative"
                maxW="300px"
              >
                {/* Card Image */}
                <Box bg="bgColor" p={2}>
                  <Image
                    src={fileTypeImg}
                    // alt={item.name}
                    objectFit="contain"
                    height="140px"
                    width="100%"
                    borderRadius="xl"
                  />
                </Box>

                {/* Card Content */}
                <VStack align="stretch" p={4} spacing={2}>
                  {/* Type Badge */}
                  <Box>
                    <Badge
                      // colorScheme={badgeColor}
                      fontSize="xs"
                      textTransform="uppercase"
                    >
                      {/* {item.type} */}
                    </Badge>
                  </Box>

                  {/* Title */}
                  <Heading
                    as="h3"
                    size="sm"
                    color="bgColor"
                    fontWeight="bold"
                    fontSize="md"
                  >
                    {directoryItem.blob}
                  </Heading>

                  {/* Description */}
                  <Text fontSize="xs" color="gray.600" noOfLines={2}>
                    {directoryItem.container}
                  </Text>
                  <a
                    download={directoryItem.blob}
                    href={`/api/getBlob?container=${directoryItem.container}&blob=${directoryItem.blob}`}
                  >
                    <Button
                      width="100%"
                      variant="primaryButton"
                      rightIcon={<DownloadIcon />}
                    >
                      Download
                    </Button>
                  </a>
                </VStack>
              </Box>
            ))}
          </SimpleGrid>
        </>
      )}
    </Box>
  );
};

export default DirectoryCards;
